import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_full",
  "use": "icon-home_full-usage",
  "viewBox": "0 0 34.02 34.02",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 34.02\" id=\"icon-home_full\"><title>icon_画板</title><path d=\"M29.22,15.23,19.33,4.78a3.19,3.19,0,0,0-4.64,0L4.8,15.23a2.23,2.23,0,0,0-.72,2.4,1.72,1.72,0,0,0,1.69,1H7.22v8a3.36,3.36,0,0,0,3.13,3.54h4.21V21.73c0-.91-.14-1.42.78-1.42h3.33c.92,0,.78.51.78,1.42v8.5h4.22a3.36,3.36,0,0,0,3.13-3.54v-8h1.44a1.73,1.73,0,0,0,1.7-1,2.23,2.23,0,0,0-.72-2.4Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol